import { Icon } from '@chakra-ui/react';

export const CloseIconNew = ({ ...props }) => (
  <Icon data-testid="close-small-icon" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5305 4.53033C12.8234 4.23744 12.8234 3.76256 12.5305 3.46967C12.2376 3.17678 11.7627 3.17678 11.4699 3.46967L8.00018 6.93934L4.53052 3.46968C4.23763 3.17679 3.76276 3.17679 3.46986 3.46968C3.17697 3.76257 3.17697 4.23745 3.46986 4.53034L6.93952 8L3.46985 11.4697C3.17696 11.7626 3.17696 12.2374 3.46985 12.5303C3.76275 12.8232 4.23762 12.8232 4.53051 12.5303L8.00018 9.06066L11.4699 12.5303C11.7628 12.8232 12.2376 12.8232 12.5305 12.5303C12.8234 12.2374 12.8234 11.7626 12.5305 11.4697L9.06084 8L12.5305 4.53033Z"
      fill="#3A495F"
    />
  </Icon>
);
